export default __webpack_public_path__ + "slices/main/assets/public/media/product/engage/engagement-layered-template@2x.0d9ff16211c89e0dde26805e518482bc.png";